import { render, staticRenderFns } from "./lucky_pet.vue?vue&type=template&id=415fda6d&"
import script from "./lucky_pet.vue?vue&type=script&lang=js&"
export * from "./lucky_pet.vue?vue&type=script&lang=js&"
import style0 from "./lucky_pet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports